module.exports = __webpack_public_path__ + "img/gongshui-1.d0a9e921.png";